import InputStatus from './InputStatus.vue';

// @ts-ignore
InputStatus.install = (Vue) => {
  Vue.component((InputStatus as any).options.name, InputStatus);
};

export default InputStatus;
